import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function FAQ() {
  const {
    t,
    tArray
  } = useLanguage();
  const faqs = tArray<{
    q: string;
    a: string;
  }>('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-ivory" id="faq" data-id="element-24" data-mp="1cft6i0y139zu">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-25" data-mp="2a2s4cf0ginzb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-26" data-mp="2a1gxu7fmn24i">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-27" data-mp="op5tx2d63w6y">
            {t('faq.title')}
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-28" data-mp="johrlkjhnsxf">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="border border-gold/20 rounded-sm bg-marble overflow-hidden" data-id="element-29" data-mp="1korrtgyfbuhi" data-mpi={idx}>
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-30" data-mp="16pidkmts3ag6">
                <span className="font-heading text-lg text-navy pr-8" data-id="element-31" data-mp="wvt6hptlwo0s">
                  {faq.q}
                </span>
                <span className={`text-saffron transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`} data-id="element-32" data-mp="mzq7utxyr7il">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-33" data-mp="2pny87va3x1qq">
                    <path d="M12 5v14M5 12h14" data-id="element-34" data-mp="2ayij0jq854d5" />
                  </svg>
                </span>
              </button>

              <AnimatePresence data-id="element-35" data-mp="38k6ff4mojmoo">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36" data-mp="33lwlsyglsu56">
                    <div className="px-6 pb-5 text-navy/70 leading-relaxed border-t border-gold/10 pt-4" data-id="element-37" data-mp="3uuppkx4g9yiq">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}